<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="8">
        <el-form-item label="停车场名称" prop="spaceId">
          <el-select v-model="query.spaceId" filterable placeholder="全部" style="width: 94%;">
            <el-option
              style="padding-left: 20px;"
              v-for="item in spaceList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="9">
        <el-form-item label="车牌号" prop="carNo">
          <el-input v-model="query.carNo" placeholder="请输入车牌号" style="width: 81%;"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="入场时间" prop="dateRange">
          <el-date-picker
            v-model="query.dateStartRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="出场时间" prop="dateRange">
          <el-date-picker
            v-model="query.dateEndRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
          <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          type="primary"
          size="small"
          @click.native="viewPic(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >查看
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="车辆图片" width="60%" append-to-body="true" :visible.sync="dialogVisible">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="block">
            <span
              style="
                display: block;
                text-align: center;
                color: #8492a6;
                font-size: 20px;
                margin-bottom: 20px;
              "
              >进场</span
            >
            <el-image :src="inPic"> </el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="block">
            <span
              style="
                display: block;
                text-align: center;
                color: #8492a6;
                font-size: 20px;
                margin-bottom: 20px;
              "
              >出场</span
            >
            <el-image :src="outPic"> </el-image>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </basic-container>
</template>
<script>
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { add, getDetail, getList, remove, update } from '@/api/v4ward/car/carinoutinfo';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      visiblePublish: '',
      spaceList: [],
      inPic: '',
      outPic: '',
      form: {},
      query: {
        spaceId: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      dialogVisible: false,
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        menuWidth: 100,
        column: [
          {
            label: '停车场',
            type: 'tree',
            prop: 'spaceId',
            props: {
              label: 'title',
              value: 'key',
            },
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            searchSpan: 8,
          },
          {
            label: '小区',
            type: 'tree',
            prop: 'areaId',
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
            searchSpan: 8,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            searchSpan: 8,
          },
          {
            label: '车辆类型',
            prop: 'carType',
          },
          {
            label: '入场时间',
            prop: 'inTime',
            searchSpan: 8,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 150,
          },
          {
            label: '入场通道',
            prop: 'inDeviceName',
          },
          {
            label: '出场时间',
            prop: 'outTime',
            searchSpan: 8,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 150,
          },
          {
            label: '出场通道',
            prop: 'outDeviceName',
          },
          {
            label: '应缴金额',
            prop: 'totalMoney',
          },
          {
            label: '实缴金额',
            prop: 'chargeMoney',
          },
          {
            label: '入场备注',
            prop: 'inMemo',
          },
          {
            label: '出场备注',
            prop: 'outMemo',
          },
          // {
          //   label: '缴费类型',
          //   prop: 'payType',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
          // },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carinoutinfo_add, false),
        viewBtn: this.vaildData(this.permission.carinoutinfo_view, false),
        delBtn: this.vaildData(this.permission.carinoutinfo_delete, false),
        editBtn: this.vaildData(this.permission.carinoutinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initSpaceList();
  },
  methods: {
    ///////////////////////////////操作按钮隐藏判断 start ////////////////////
    hideApplyBtn(row) {
      //    --》隐藏【申请】按钮
      return row.inPic === '' && row.outPic === '';
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    initSpaceList() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          this.query.spaceId = this.spaceList[0].id;
          this.onLoad();
        }
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      // if (['edit','view'].includes(type)) {
      //   getDetail({ id: this.form.id }).then(({ data }) => {
      //     this.form = data;
      //   });
      // }
      // done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.dateStartRange) {
        this.query.inTimeS = this.query.dateStartRange[0];
        this.query.inTimeE = this.query.dateStartRange[1];
      }
      if (this.query.dateEndRange) {
        this.query.outTimeS = this.query.dateEndRange[0];
        this.query.outTimeE = this.query.dateEndRange[1];
      }
      if (this.spaceList.length > 0) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      } else {
        this.loading = false;
      }
    },
    viewPic(row) {
      this.dialogVisible = true;
      this.inPic = row.inPic;
      this.outPic = row.outPic;
    },
  },
};
</script>

<style></style>
